import React from 'react';
import BlockSkeleton from '../../../../components/Skeleton/BlockSkeleton';
import TextSkeleton from '../../../../components/Skeleton/TextSkeleton';

import Classes from './SellerInfoSkeleton.scss';

const INDICATORS_COUNTER = 5;
const indicators = Array(INDICATORS_COUNTER)
  .fill(0)
  .map((_, index) => index + 1);

const SellerInfoSkeleton = () => {
  return (
    <div>
      <div className={Classes.header}>
        <BlockSkeleton className={Classes.avatar} withAnimation={true} />
        <div className={Classes.headerContent}>
          <TextSkeleton withAnimation={true} />
          <TextSkeleton withAnimation={true} />
        </div>
        <BlockSkeleton className={Classes.followButton} withAnimation={true} />
      </div>
      <div className={Classes.indicators} key={0}>
        {indicators.map((key) => (
          <div key={key} className={Classes.indicator}>
            <BlockSkeleton className={Classes.indicatorIcon} withAnimation={true} />
            <div className={Classes.indicatorContent}>
              <TextSkeleton withAnimation={true} />
              <TextSkeleton withAnimation={true} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SellerInfoSkeleton;
